import { Component, OnInit } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
  selector: 'app-not-authorized',
  templateUrl: './not-authorized.component.html',
  styleUrls: ['./not-authorized.component.scss']
})
export class NotAuthorizedComponent implements OnInit {

  logged = false;

  constructor(private oauthService: OAuthService) {
    this.logged = this.oauthService.hasValidAccessToken();
  }

  ngOnInit(): void {  }

  logout(): void {
    this.oauthService.logOut();
  }
}
